var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path4, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _path5, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path6, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _path7, _path8, _path9, _path0, _path1, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _path10, _path11, _path12, _path13, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreateMonitor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 520 360"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 520,
  height: 360,
  fill: "#fff",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#create-monitor_svg__a)",
  fillOpacity: 0.2,
  d: "M0 20C0 8.954 8.954 0 20 0h480c11.046 0 20 8.954 20 20v210L0 140z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E73C3",
  stroke: "#333",
  strokeWidth: 7,
  d: "M366.5 102.5h73v127h-73z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 4,
  x: 393,
  y: 111,
  fill: "#fff",
  rx: 2
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 4,
  x: 372,
  y: 111,
  fill: "#fff",
  rx: 2
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 4,
  x: 425,
  y: 111,
  fill: "#fff",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M371.973 120.267h62.048v1h-62.048z"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 6.331,
  height: 6.14,
  x: 372.379,
  y: 123.414,
  fill: "#fff",
  rx: 3.07
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  width: 6.331,
  height: 6.14,
  x: 372.379,
  y: 135.501,
  fill: "#fff",
  rx: 3.07
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 6.14,
  x: 380.402,
  y: 123.414,
  fill: "#fff",
  rx: 3.07
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  width: 24.174,
  height: 6.14,
  x: 380.402,
  y: 135.501,
  fill: "#fff",
  rx: 3.07
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 6.14,
  x: 425.203,
  y: 123.414,
  fill: "#fff",
  rx: 3.07
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 6.14,
  x: 425.203,
  y: 135.501,
  fill: "#fff",
  rx: 3.07
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M371.973 132.355h62.048v1h-62.048zM371.973 144.442h62.048v1h-62.048z",
  opacity: 0.5
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  width: 6.331,
  height: 6.14,
  x: 372.379,
  y: 147.972,
  fill: "#fff",
  rx: 3.07
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  width: 6.331,
  height: 6.14,
  x: 372.379,
  y: 160.059,
  fill: "#fff",
  rx: 3.07
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 6.14,
  x: 380.402,
  y: 147.972,
  fill: "#fff",
  rx: 3.07
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  width: 24.174,
  height: 6.14,
  x: 380.402,
  y: 160.059,
  fill: "#fff",
  rx: 3.07
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 6.14,
  x: 425.203,
  y: 147.972,
  fill: "#fff",
  rx: 3.07
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 6.14,
  x: 425.203,
  y: 160.059,
  fill: "#fff",
  rx: 3.07
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M371.973 156.913h62.048v1h-62.048zM371.973 169h62.048v1h-62.048z",
  opacity: 0.5
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 171.302,
  fill: "#fff",
  rx: 1.612
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 177.346,
  fill: "#fff",
  rx: 1.612
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 183.39,
  fill: "#fff",
  rx: 1.612
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 189.433,
  fill: "#fff",
  rx: 1.612
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 3.223,
  x: 379.637,
  y: 171.302,
  fill: "#fff",
  rx: 1.612
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  width: 16.116,
  height: 3.223,
  x: 379.637,
  y: 177.346,
  fill: "#fff",
  rx: 1.612
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  width: 24.174,
  height: 3.223,
  x: 379.637,
  y: 183.39,
  fill: "#fff",
  rx: 1.612
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 3.223,
  x: 379.637,
  y: 189.433,
  fill: "#fff",
  rx: 1.612
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 171.302,
  fill: "#fff",
  rx: 1.612
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 177.346,
  fill: "#fff",
  rx: 1.612
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 183.39,
  fill: "#fff",
  rx: 1.612
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 189.433,
  fill: "#fff",
  rx: 1.612
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M371.973 175.734h62.048v1h-62.048zM371.973 181.778h62.048v1h-62.048zM371.973 187.822h62.048v1h-62.048zM371.973 193.865h62.048v1h-62.048z",
  opacity: 0.5
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 195.86,
  fill: "#fff",
  rx: 1.612
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 201.904,
  fill: "#fff",
  rx: 1.612
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 207.948,
  fill: "#fff",
  rx: 1.612
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  width: 4.029,
  height: 3.223,
  x: 372.379,
  y: 213.991,
  fill: "#fff",
  rx: 1.612
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 3.223,
  x: 379.637,
  y: 195.86,
  fill: "#fff",
  rx: 1.612
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  width: 16.116,
  height: 3.223,
  x: 379.637,
  y: 201.904,
  fill: "#fff",
  rx: 1.612
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  width: 24.174,
  height: 3.223,
  x: 379.637,
  y: 207.948,
  fill: "#fff",
  rx: 1.612
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  width: 20.145,
  height: 3.223,
  x: 379.637,
  y: 213.991,
  fill: "#fff",
  rx: 1.612
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 195.86,
  fill: "#fff",
  rx: 1.612
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 201.904,
  fill: "#fff",
  rx: 1.612
})), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 207.948,
  fill: "#fff",
  rx: 1.612
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  width: 8.058,
  height: 3.223,
  x: 425.969,
  y: 213.991,
  fill: "#fff",
  rx: 1.612
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M371.973 200.292h62.048v1h-62.048zM371.973 206.336h62.048v1h-62.048zM371.973 212.38h62.048v1h-62.048zM371.973 218.423h62.048v1h-62.048z",
  opacity: 0.5
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M393.789 69h18v30h-18z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E73C3",
  stroke: "#333",
  strokeWidth: 10,
  d: "M88 95h250v145H88z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M113 70h30v20h-30zM283 70h30v20h-30z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  d: "M62 50h458v20H62z"
})), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 9,
  x: 175.5,
  y: 106,
  fill: "#fff",
  rx: 4.5
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 9,
  x: 99,
  y: 106,
  fill: "#fff",
  rx: 4.5
})), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 12,
  x: 99,
  y: 136,
  fill: "#fff",
  rx: 6
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 12,
  x: 99,
  y: 158.5,
  fill: "#fff",
  rx: 6
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 12,
  x: 99,
  y: 181,
  fill: "#fff",
  rx: 6
})), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 12,
  x: 99,
  y: 203.5,
  fill: "#fff",
  rx: 6
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 12,
  x: 126,
  y: 136,
  fill: "#fff",
  rx: 6
})), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 12,
  x: 126,
  y: 158.5,
  fill: "#fff",
  rx: 6
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 12,
  x: 126,
  y: 181,
  fill: "#fff",
  rx: 6
})), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 12,
  x: 126,
  y: 203.5,
  fill: "#fff",
  rx: 6
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 12,
  x: 298.5,
  y: 136,
  fill: "#fff",
  rx: 6
})), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 12,
  x: 298.5,
  y: 158.5,
  fill: "#fff",
  rx: 6
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 12,
  x: 298.5,
  y: 181,
  fill: "#fff",
  rx: 6
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 12,
  x: 298.5,
  y: 203.5,
  fill: "#fff",
  rx: 6
})), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 9,
  x: 297,
  y: 106,
  fill: "#fff",
  rx: 4.5
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M97.5 130h231v1.5h-231z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M97.5 152.5h231v1.5h-231zM97.5 175h231v1.5h-231zM97.5 197.5h231v1.5h-231zM97.5 220h231v1.5h-231z",
  opacity: 0.5
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2E73C3",
  stroke: "#333",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "M250 215h166v96H250z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M233 314h200c0 5.523-4.477 10-10 10H243c-5.523 0-10-4.477-10-10"
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 6,
  x: 308,
  y: 222,
  fill: "#fff",
  rx: 3
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 6,
  x: 257,
  y: 222,
  fill: "#fff",
  rx: 3
})), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 8,
  x: 257,
  y: 242,
  fill: "#fff",
  rx: 4
})), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 8,
  x: 257,
  y: 257,
  fill: "#fff",
  rx: 4
})), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 8,
  x: 257,
  y: 272,
  fill: "#fff",
  rx: 4
})), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
  width: 10,
  height: 8,
  x: 257,
  y: 287,
  fill: "#fff",
  rx: 4
})), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 8,
  x: 275,
  y: 242,
  fill: "#fff",
  rx: 4
})), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 8,
  x: 275,
  y: 257,
  fill: "#fff",
  rx: 4
})), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 8,
  x: 275,
  y: 272,
  fill: "#fff",
  rx: 4
})), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 8,
  x: 275,
  y: 287,
  fill: "#fff",
  rx: 4
})), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 8,
  x: 390,
  y: 242,
  fill: "#fff",
  rx: 4
})), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 8,
  x: 390,
  y: 257,
  fill: "#fff",
  rx: 4
})), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 8,
  x: 390,
  y: 272,
  fill: "#fff",
  rx: 4
})), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 8,
  x: 390,
  y: 287,
  fill: "#fff",
  rx: 4
})), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 6,
  x: 389,
  y: 222,
  fill: "#fff",
  rx: 3
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M256 238h154v1H256zM256 253h154v1H256zM256 268h154v1H256zM256 283h154v1H256zM256 298h154v1H256z",
  opacity: 0.5
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "create-monitor_svg__a",
  x1: 260,
  x2: 260,
  y1: 0,
  y2: 275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007AC9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007AC9",
  stopOpacity: 0
})))));
export { SvgCreateMonitor as ReactComponent };